import { render, staticRenderFns } from "./casetjhfbdls.vue?vue&type=template&id=88740a38&"
import script from "./casetjhfbdls.vue?vue&type=script&lang=js&"
export * from "./casetjhfbdls.vue?vue&type=script&lang=js&"
import style0 from "./casetjhfbdls.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports